<script lang="ts">
  import { Block } from '@reuters-graphics/graphics-components';
  import Clock from './Clock.svelte';

  let { clockSize = 'XS', clockWeight = 'Bold' } = $props();

  let windowWidth: number = $state(1);
</script>

<svelte:window bind:innerWidth={windowWidth} />

<Block>
  <div
    id="clock-group"
    style={windowWidth < 660 ? 'justify-content: center;' : ''}
  >
    <Clock
      name="Jerusalem"
      tzIdentifier="Asia/Jerusalem"
      {clockSize}
      {clockWeight}
    />
    <Clock name="Tehran" tzIdentifier="Asia/Tehran" {clockSize} {clockWeight} />
    <Clock
      name="Washington"
      tzIdentifier="America/New_York"
      {clockSize}
      {clockWeight}
    />
  </div>
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  div#clock-group {
    max-width: 500px;
    margin: -20px auto 40px;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-between;
  }
</style>
